// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xtm1","rootNoMargin":"styles_rootNoMargin__1GOin"};